import { DotMatrix } from '@clickguard/design-system'

import { classNames } from 'utils'

export const GLoading = (props: {
	label?: string
	className?: string
	addMargin?: boolean
	size?: number
}) => {
	const { label, addMargin = true, size = 8, className } = props
	// Keep the legacy footprint while using the matrix's own dot geometry.
	const footprintClass =
		size === 6 ? 'h-6 w-6' : size === 4 ? 'h-4 w-4' : 'h-8 w-8'
	const matrixSize = size === 6 ? 'sm' : size === 4 ? 'xs' : 'md'
	return (
		<div
			className={classNames(
				'w-full h-full flex flex-col items-center justify-center',
				label ? 'gap-3' : '',
				addMargin ? 'p-4 m-6' : '',
				className || ''
			)}
		>
			<div
				className={`flex flex-shrink-0 items-center justify-center ${footprintClass}`}
			>
				<DotMatrix size={matrixSize} label={label} />
			</div>
			{label && <span className="text-center">{label}</span>}
		</div>
	)
}

export const GLazyLoading = () => {
	return (
		<div className="h-96 flex flex-col justify-end items-center text-center space-y-4">
			<DotMatrix size="lg" />
			<span className="w-full text-center text-t-secondary">Loading...</span>
		</div>
	)
}
